import { render, staticRenderFns } from "./StudioTabbar.vue?vue&type=template&id=78fd6b96&scoped=true&"
import script from "./StudioTabbar.vue?vue&type=script&lang=js&"
export * from "./StudioTabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd6b96",
  null
  
)

export default component.exports